import { Component } from '@angular/core';

@Component({
  selector: 'app-guide-enterprise-dashboard',
  templateUrl: './guide-enterprise-dashboard.component.html',
  styleUrls: ['./guide-enterprise-dashboard.component.scss']
})
export class GuideEnterpriseDashboardComponent {

}
